module.exports = __webpack_public_path__ + "img/jambyl5.f64c918c.jpg";